import { render, staticRenderFns } from "./FileUploadAiInspect.vue?vue&type=template&id=83b3901c&scoped=true"
import script from "./FileUploadAiInspect.vue?vue&type=script&lang=js"
export * from "./FileUploadAiInspect.vue?vue&type=script&lang=js"
import style0 from "./FileUploadAiInspect.vue?vue&type=style&index=0&id=83b3901c&prod&scoped=true&lang=css"
import style1 from "./FileUploadAiInspect.vue?vue&type=style&index=1&id=83b3901c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b3901c",
  null
  
)

export default component.exports